import Vue from "vue";
import VueRouter from "vue-router";
import Home from "../views/Home.vue";
import Things from "../views/Things.vue";
import Touch from "../views/Touch.vue";
import Company from "../views/Company.vue";
import CompanyIntro from "../views/company/CompanyIntro.vue";
import Chairman from "../views/company/Chairman.vue";
import Culture from "../views/company/Culture.vue";
import Environment from "../views/company/Environment.vue";
import Honor from "../views/company/Honor.vue";
import Patent from "../views/company/Patent.vue";
import Join from "../views/company/Join.vue";
import Connect from "../views/company/Connect.vue";
import Project from "../views/Project.vue";
import News from "../views/News.vue";
import Aftersale from "../views/Aftersale";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home
  },
  {
    path: "/things",
    name: "Things",
    component: Things
  },
  {
    path: "/touch",
    name: "Touch",
    component: Touch
  },
  {
    path: "/company",
    name: "Company",
    component: Company,
    children: [
      { path: "companyintro", component: CompanyIntro },
      { path: "chairman", component: Chairman },
      { path: "culture", component: Culture },
      { path: "environment", component: Environment },
      { path: "honor", component: Honor },
      { path: "patent", component: Patent },
      { path: "join", component: Join },
      { path: "connect", component: Connect }
    ]
  },
  {
    path: "/project",
    name: "Project",
    component: Project
  },
  {
    path: "/news",
    name: "News",
    component: News
  },
  {
    path: "/aftersale",
    name: "Aftersale",
    component: Aftersale
  }
];

const router = new VueRouter({
  routes
});

export default router;
